import React from 'react';
import { Form, reduxForm } from 'redux-form';
import { HashLoader } from 'react-spinners';

import AppModal from '../../../modal/appModal';
import { FormId } from '../../../../constants/formId';
import { SimpleModalId } from '../../../../constants/modalId';
import { AppFileField } from '../../../form/appFileField';
import { AppSelectField } from '../../../form/appSelectField';
import { AppTextField } from '../../../form/appTextField';
import { AppTextAreaField } from '../../../form/appTextAreaField';
import { required } from '../../../form/formValidations';
import {
  EditParticipantFormDataProps,
  EditParticipantFormOwnProps,
  EditParticipantFormOnSubmitProps,
  ParticipantFormFieldsProps,
} from '../participant.types';
import {
  allowedAudioExtensions,
  allowedImageExtensions,
  allowedVideoExtensions,
  validateAudioFile,
  validateImageFile,
  validateVideoFile,
} from '../../utils/fileValidators';
import styles from '../../ClipGeneratorPage.module.scss';

const ParticipantFormFields = ({ orderIndexOptions }: ParticipantFormFieldsProps) => (
  <>
    <AppSelectField name="orderIndex" label="Order Index" options={orderIndexOptions} validate={[required]} />
    <AppTextField name="firstName" label="First Name" validate={[required]} />
    <AppTextField name="lastName" label="Last Name" validate={[required]} />
    <AppTextField name="firstSubtitle" label="Subtitle 1" validate={[required]} />
    <AppTextField name="secondSubtitle" label="Subtitle 2" />
    <AppTextAreaField name="message" label="Message" />
    <AppFileField name="image" label="Image" extensions={allowedImageExtensions} validate={validateImageFile} />
    <AppFileField
      name="liveVideo"
      label="Live Video"
      extensions={allowedVideoExtensions}
      validate={validateVideoFile}
    />
    <AppFileField
      name="messageVideo"
      label="Message Video"
      extensions={allowedVideoExtensions}
      validate={validateVideoFile}
    />
    <AppFileField name="audio" label="Audio" extensions={allowedAudioExtensions} validate={validateAudioFile} />
    <AppFileField name="slide" label="Slide" extensions={allowedImageExtensions} validate={validateImageFile} />
  </>
);

const EditParticipantForm = ({
  form,
  handleSubmit,
  orderIndexOptions,
  isLoading,
  onSubmit,
}: EditParticipantFormOwnProps) => {
  const handleOnSubmit = (values: EditParticipantFormDataProps) => onSubmit(values);

  return (
    <AppModal
      form={form}
      title="Edit Participant"
      id={SimpleModalId.EditAfterEffectsParticipantModal}
      hideOpenButton
      hideActionButtons={isLoading}
      className={styles.modal}
    >
      {isLoading ? (
        <div className={styles.loader}>
          <HashLoader />
        </div>
      ) : (
        <Form id={form} onSubmit={handleSubmit(handleOnSubmit)}>
          <ParticipantFormFields orderIndexOptions={orderIndexOptions} />
        </Form>
      )}
    </AppModal>
  );
};

export const EditParticipantFormContainer = reduxForm<EditParticipantFormDataProps, EditParticipantFormOnSubmitProps>({
  form: FormId.EditAfterEffectsParticipantForm,
  enableReinitialize: true,
})(EditParticipantForm);
